<form>
  <ng-container *transloco="let t; read: 'ime.system.user'">
    <div class="form-group row">
      <label for="fullname" class="col-sm-2 col-form-label">{{t('Fullname')}}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="fullname" name="fullname" [(ngModel)]="user.Fullname">
      </div>
    </div>
    <div class="form-group row">
      <label for="email" class="col-sm-2 col-form-label">{{t('Email')}}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="email" name="email" autocomplete="new-email" [(ngModel)]="user.Email">
      </div>
    </div>
    <div class="form-group row">
      <label for="language" class="col-sm-2 col-form-label">{{t('Language')}}</label>
      <div class="col-sm-10">
        <ng-select class="select-sm form-control" [virtualScroll]="true" [items]="languageService.getAll$ | async"
                   bindValue="Id" bindLabel="Code" [(ngModel)]="user.LanguageId" name="language" id="language">
        </ng-select>
      </div>
    </div>
    <div class="form-group row">
      <label for="password" class="col-sm-2 col-form-label">{{t('Password')}}</label>
      <div class="col-sm-10">
        <input type="password" class="form-control" id="password" name="password" autocomplete="new-password" [(ngModel)]="user.Password">
      </div>
    </div>
    <div class="form-group row">
      <label for="user-RoleIds" class="col-sm-2 col-form-label">{{t('Roles')}}</label>
      <div class="col-sm-10">
        <mes-role-select [items$]="rolesService.$getAll" [entityIds]="user.RoleIds"
                         (entityIdsChange)="user.RoleIds = $event; userChanged.emit(false)" name="user-RoleIds" id="user-RoleIds"></mes-role-select>
      </div>
    </div>
  </ng-container>
</form>
